const productEnrichmentRoutes = [
  {
    path: '/products/enrichments',
    name: 'products.enrichments.index',
    component: () => import('@/modules/Products/views/ProductEnrichmentList.vue'),
    meta: {
      roles: [1, 2, 5, 6],
      pageTitle: 'Enriquecimento de Produtos',
      breadcrumb: [
        {
          text: 'Enrichments',
          active: true,
        },
      ],
    },
  },
]

export default productEnrichmentRoutes
